import { AiChatDrawer, useFoundryAgentRuntime } from '@strata/react-ai-chat';
import { IconButton } from '@strata/react-buttons';
import FmhAiIcon from '@strata/strata-ui/assets/illustrations/FMH-AI.svg?react';
import { useCallback, useState } from 'react';

import { PAYER_REQUEST_API_URL } from 'api/APIBase';
import { useAppSelector } from 'store';

const REQUESTS_AGENT_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/${PAYER_REQUEST_API_URL}/ai/requests/invoke`;

interface FmhAiChatProps {
    payerId: string;
    requestNumber: string;
}

/** FMH AI launcher: an icon button that opens the AI chat drawer. */
export const FmhAiChat = ({ payerId, requestNumber }: FmhAiChatProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const accessToken = useAppSelector((state) => state.auth.accessToken);

    const getHeaders = useCallback(
        () => ({ Authorization: `Bearer ${accessToken}` }),
        [accessToken],
    );
    const runtime = useFoundryAgentRuntime({
        endpoint: REQUESTS_AGENT_ENDPOINT,
        getHeaders,
        instructions: `Context: ${payerId} / ${requestNumber} (default case unless stated otherwise).`,
    });

    return (
        <>
            <IconButton
                tooltip="FMH AI"
                icon={
                    <FmhAiIcon
                        role="button"
                        aria-label="FMH AI"
                        height={29}
                        width={29}
                        onClick={() => setIsOpen(true)}
                    />
                }
            />
            <AiChatDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} runtime={runtime} />
        </>
    );
};
